import { useMemo } from 'react'

import { useContractUuid } from 'hooks/useContractUuid'

type UserConfig = RequestInit & { customResponseHandling?: boolean }

const request = async <TResponse>(
  url: string,
  userConfig?: UserConfig
): Promise<TResponse> => {
  const config: RequestInit = {
    ...userConfig,
    headers: {
      ...userConfig?.headers,
    },
  }
  const res = await fetch(url, config)

  if (!userConfig?.customResponseHandling) {
    if (res.status !== 200) {
      throw new Error('Failed to fetch!')
    }

    const json = await res.json()
    return json
  }

  return res as TResponse
}

export const useApi = () => {
  const slug = useContractUuid()

  return useMemo(
    () => ({
      get: <TResponse>(url: string, userConfig?: UserConfig) =>
        request<TResponse>(url, {
          ...userConfig,
          headers: { ...userConfig?.headers, 'x-tenant-slug': slug },
        }),
      post: <TBody, TResponse>(
        url: string,
        body: TBody,
        userConfig?: UserConfig
      ) =>
        request<TResponse>(url, {
          ...userConfig,
          method: 'POST',
          headers: {
            ...userConfig?.headers,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-tenant-slug': slug,
          },
          body: JSON.stringify(body || null),
        }),
    }),
    [slug]
  )
}
